var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('schema-editor',{attrs:{"schema":_vm.schema,"sources":_vm.sources},on:{"save":function($event){return _vm.update(false)},"save-and-exit":function($event){return _vm.update(true)}}})}
var staticRenderFns = []

export { render, staticRenderFns }